/* Copyright 2020 VMware, Inc. All rights reserved. -- VMware Confidential */

module platform {
   class StackViewOverridesDirective implements ng.IDirective {
      public restrict = 'A';

      private changes: MutationObserver | null;
      private elements: Element[] = [];

      link(scope: ng.IScope, element: ng.IAugmentedJQuery) {

         this.setupObserver(element);

         scope.$on("$destroy", () => {
            this.onDestroy();
         });
      }

      /**
       * There are stack view components that are dynamically adding and removing stack blocks
       * ex. Edit Settings of VM, so we need to stop the propagation for the new elements as well
       */
      private setupObserver(element: ng.IAugmentedJQuery) {
         this.changes = new MutationObserver((mutations: MutationRecord[]) => {
            if (mutations) {
               for (let mutation of mutations) {
                  this.stopEventPropagationOnStackContent(mutation);
               }
            }
         });
         this.changes.observe(element[0], {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class"]
         });
      }

      private stopPropagation(event: Event) {
         event.stopPropagation();
      }

      private stopEventPropagationOnStackContent(mutation: MutationRecord) {
         if (mutation.target.nodeType !== Node.ELEMENT_NODE) {
            return;
         }

         const element = (mutation.target) as Element;
         if (element.tagName !== "CLR-STACK-BLOCK") {
            return;
         }

         if (!element.classList || !element.classList.contains("stack-block-expandable")) {
            return;
         }

         const expandableStackBlockContent = element.querySelector(
               ".stack-block-label .stack-block-content");
         if (expandableStackBlockContent) {
            expandableStackBlockContent.addEventListener("click", this.stopPropagation);
            this.elements.push(expandableStackBlockContent);
         }
      }

      private onDestroy() {
         this.elements.forEach((element) => {
            element.removeEventListener("click", this.stopPropagation);
         });
      }

      static MetaStructure: ng.IDirectiveFactory = {
         factory: [() => new StackViewOverridesDirective()]
      };
   }

   angular
         .module("com.vmware.platform.ui")
         .directive("stackViewOverrides", StackViewOverridesDirective.MetaStructure.factory);
}
